/**
 * Created by B032151 on 1/4/2017.
 */
import { ServerActions } from "./serverActions";
import { UserActions } from "./userActions";
import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
import { Stomp } from "../libs/Stomp";

const { ActionTypes } = Constants;
let WsConstants = Constants.WebSocketConstants;

let socket;
let client;

function initialize() {
  try {
    const token = window.gritConfig.authUser.access_token;
    console.log ("connecting with token", token);
    socket = new SockJS("/websocket");
    client = Stomp.over(socket);

    let headers = {
      "X-Authorization": "Bearer " + token
    }

    client.connect(headers, function () {
      client.subscribe(
        WsConstants.USER_OVERRIDE_GRANTED_QUEUE,
        function (message) {
          onOverrideGrantedMessageHandler(message);
        }
      );

      client.subscribe(
        WsConstants.USER_OVERRIDE_EXPIRED_QUEUE,
        function (message) {
          onOverrideExpiredMessageHandler(message);
        }
      );

      client.subscribe(
        WsConstants.USER_OUTAGE_BANNER_START_TIME_QUEUE,
        function (message) {
          setOutageDetail(message);
        }
      );

      client.subscribe(
        WsConstants.USER_OUTAGE_START_TIME_QUEUE,
        function (message) {
          setOutageDetail(message);
        }
      );

      client.subscribe(
        WsConstants.USER_OUTAGE_END_TIME_QUEUE,
        function (message) {
          setOutageDetail(message);
        }
      );
    });
  } catch (e) {
    console.error(e);
    console.error("Hit error while trying to initialize websockets");
  }
}

function onOverrideGrantedMessageHandler(message) {
  var data = JSON.parse(message.body);

  dispatcher.dispatch({
    type: ActionTypes.OVERRIDE_GRANTED,
    override: data,
  });
  dispatcher.dispatch({
    type: ActionTypes.SHOW_DEFAULT_TRACKS_VALUE_CHANGED,
    value: true,
  });
}

function onOverrideExpiredMessageHandler(message) {
  var data = JSON.parse(message.body);

  dispatcher.dispatch({
    type: ActionTypes.OVERRIDE_EXPIRED,
    override: data,
    fromAdmin: true,
  });
  dispatcher.dispatch({
    type: ActionTypes.SHOW_DEFAULT_TRACKS_VALUE_CHANGED,
    value: false,
  });
}

function onOverrideCheckMessageHandler(message) {
  var data = message;

  UserActions.getActiveOverride({ userId: window.gritConfig.userId });
}

function setOutageDetail(message) {
  ServerActions.setOutageDetail();
}

export const WsActions = {
  initialize,
};
